import { recover } from "@/plugins/keythereum";
/**
 * 此hook提供给浏览器环境使用
 */
const IS_ELECTRON = process.env.IS_ELECTRON;

export const useCrypto = async () => {
  let encryptMessage: (publicKey: string, message: string) => Promise<string>;

  let decryptMessage: (privateKey: string, data: string) => Promise<string>;

  if (IS_ELECTRON) {
    encryptMessage = window.electronAPI.encryptMessage;
    decryptMessage = window.electronAPI.decryptMessage;
  } else {
    const res = await import("@/plugins/crypto");
    encryptMessage = async (publicKey: string, message: string) => {
      return res.encryptMessage(publicKey, message);
    };
    decryptMessage = async (privateKey: string, data: string) => {
      return res.decryptMessage(privateKey, data);
    };
  }
  function decryptPasswordToMessage(
    password: string,
    data: string,
    keystore: Parameters<typeof recover>["0"]["keystore"]
  ) {
    const privateKey = recover({
      password,
      keystore,
    });
    return decryptMessage(privateKey, data);
  }
  return {
    encryptMessage,
    decryptMessage,
    decryptPasswordToMessage,
  };
};
